import { render, staticRenderFns } from "./InventoryStatsCard.vue?vue&type=template&id=75d09c5d"
import script from "./InventoryStatsCard.vue?vue&type=script&lang=js"
export * from "./InventoryStatsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports